import { render, staticRenderFns } from "./ImagemapView.vue?vue&type=template&id=854d8530&scoped=true&"
import script from "./ImagemapView.vue?vue&type=script&lang=js&"
export * from "./ImagemapView.vue?vue&type=script&lang=js&"
import style0 from "./ImagemapView.vue?vue&type=style&index=0&id=854d8530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854d8530",
  null
  
)

export default component.exports